
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Familyresortinnagpurdistrictsurroundedbynature() {



  const cardData =
  {
    keyword: ' Family Resort in Nagpur District Surrounded by Nature',
    heading:  'Woodland Escape: Family Resort in Nagpur District Surrounded by Nature ',
    headingDescription: 'Woodland Escape Resort is a serene family resort in Nagpur District surrounded by nature, offering the perfect mix of comfort, relaxation, and outdoor charm. Tucked away amidst lush greenery, forested trails, and wide-open lawns, the resort provides families with a peaceful environment to unwind and reconnect. Parents can relax in cozy cottages while children enjoy safe outdoor spaces, games, and nature walks. The calm surroundings, delicious home-style meals, and warm hospitality make every stay feel like a retreat into nature’s lap. Whether it’s a weekend getaway or a short family vacation, Woodland Escape Resort near Nagpur ensures a rejuvenating escape filled with togetherness, laughter, and the soothing beauty of the outdoors.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Family Resort in Nagpur District Surrounded by Nature",
      "description": "Experience a rejuvenating stay at this family resort in Nagpur district, nestled amidst lush greenery and serene landscapes. The resort offers spacious accommodations, nature trails, outdoor play areas for kids, and tranquil spots for relaxation. Perfect for family getaways, the resort combines comfort with eco-friendly practices, allowing guests to reconnect with nature while enjoying modern amenities. Activities include guided forest walks, riverside picnics, and evening bonfires to create memorable family moments."
    },
    {
      "name": "Nagpur Nature Family Resort",
      "description": "Enjoy a peaceful retreat at Nagpur Nature Family Resort, designed for families seeking a blend of adventure and relaxation. Surrounded by hills, forests, and rivers, the resort provides activities like nature treks, birdwatching, and interactive sessions for children. Guests can indulge in local cuisine, enjoy riverside lounging, or participate in organized outdoor games. Ideal for weekends and holidays, this resort offers a refreshing escape from city life, fostering bonding and exploration in a natural setting."
    },
    {
      "name": "Nagpur Eco-Friendly Family Stay",
      "description": "Stay sustainably at this eco-friendly family resort in Nagpur, where green living meets comfort. The resort emphasizes low-impact tourism with solar energy, organic gardens, and water conservation initiatives. Families can engage in educational nature activities, outdoor sports, and scenic walks, while children enjoy safe play zones. With cozy cottages and environmentally-conscious amenities, this resort ensures a responsible yet luxurious experience amidst lush forests and calming rivers."
    },
    {
      "name": "Nagpur Weekend Family Nature Resort",
      "description": "Make weekends memorable at Nagpur Weekend Family Nature Resort, offering an immersive experience in nature. Guests can explore hiking trails, enjoy riverside picnics, and relax in forest-view accommodations. The resort hosts weekend-specific activities like guided nature walks, storytelling sessions for kids, and family yoga classes. With delicious local meals and well-maintained outdoor spaces, this resort is perfect for families looking to unwind, bond, and enjoy an adventurous yet peaceful retreat."
    },
    {
      "name": "Nagpur Forest View Family Resort",
      "description": "Wake up to panoramic forest views at Nagpur Forest View Family Resort, designed for families who love nature and tranquility. The resort offers cottages with private balconies, nature trails, and outdoor activity zones. Families can enjoy morning birdwatching, evening bonfires, and educational workshops about local flora and fauna. With a focus on safety and comfort, this resort is perfect for kids and adults alike, offering a refreshing escape with unforgettable natural experiences."
    },
    {
      "name": "Nagpur Riverside Family Resort",
      "description": "Relax and unwind by the river at Nagpur Riverside Family Resort, where families can enjoy serene water views, boating activities, and riverside picnics. The resort features comfortable accommodations, play areas, and scenic walking paths along the riverbank. Guests can also enjoy evening campfires, local cultural programs, and guided nature tours. Ideal for weekend getaways and family bonding, this resort combines adventure, relaxation, and natural beauty in one memorable stay."
    },
    {
      "name": "Nagpur Hill Family Resort",
      "description": "Discover a refreshing hilltop retreat at Nagpur Hill Family Resort, offering breathtaking views and a cool, peaceful environment. The resort provides family-friendly accommodations, outdoor sports facilities, trekking trails, and safe play areas for children. Guests can participate in guided hikes, birdwatching tours, and evening bonfires. Perfect for nature lovers and adventure seekers, this resort ensures families enjoy both relaxation and exploration amidst scenic hills."
    },
    {
      "name": "Nagpur Outdoor Activity Family Resort",
      "description": "Engage in fun and adventure at Nagpur Outdoor Activity Family Resort, featuring a wide range of activities for all age groups. Families can enjoy zip-lining, nature trails, cycling, kayaking, and organized games. Comfortable accommodations and eco-conscious practices create a safe and immersive environment for kids and adults alike. Ideal for family weekends or short breaks, this resort combines outdoor excitement with serene natural surroundings for a complete getaway experience."
    },
    {
      "name": "Nagpur Nature Adventure Resort",
      "description": "Explore thrilling adventures while staying close to nature at Nagpur Nature Adventure Resort. The resort offers guided treks, wildlife spotting tours, riverside activities, and interactive nature workshops for children. Families can enjoy comfortable cottages, picnic spots, and evening cultural programs. Designed for adventure enthusiasts and nature lovers, this resort provides a perfect mix of excitement, education, and relaxation amidst lush landscapes."
    },
    {
      "name": "Nagpur Group Family Resort",
      "description": "Ideal for large families and group gatherings, Nagpur Group Family Resort offers spacious accommodations, multiple activity zones, and organized events. Families can enjoy group games, outdoor excursions, nature trails, and riverside picnics. The resort ensures safety, comfort, and entertainment for all age groups, making it perfect for reunions, celebrations, and weekend getaways in a scenic, family-friendly environment."
    },
    {
      "name": "Nagpur Kids Friendly Nature Resort",
      "description": "Designed with children in mind, Nagpur Kids Friendly Nature Resort provides safe play zones, educational nature activities, and interactive workshops. Families can explore nature trails, riverside areas, and open fields, while kids enjoy supervised games, storytelling sessions, and adventure activities. Comfortable accommodations, eco-conscious practices, and recreational options make it an ideal destination for families seeking both fun and learning in a natural environment."
    },
    {
      "name": "Nagpur Booking for Family Resort",
      "description": "Easily secure your stay at Nagpur Family Resorts through convenient online booking. Choose from a variety of family-friendly accommodations, activity packages, and nature experiences. The resorts offer flexible booking options, special weekend packages, and personalized services to ensure a hassle-free and memorable family getaway. Perfect for planning vacations, reunions, or short nature retreats with family and friends."
    },
    {
      "name": "Nagpur Luxury Family Nature Resort",
      "description": "Indulge in luxury amidst nature at Nagpur Luxury Family Nature Resort, featuring high-end accommodations, private cottages, spa facilities, and gourmet dining. Families can enjoy curated nature activities, guided treks, riverside picnics, and evening cultural events. The resort combines modern comfort with eco-friendly living, offering an unforgettable experience for families seeking both relaxation and adventure in a scenic natural setting."
    },
    {
      "name": "Nagpur One Day Family Resort",
      "description": "Perfect for a short getaway, Nagpur One Day Family Resort offers a full day of outdoor fun, nature exploration, and family bonding activities. Guests can enjoy riverside picnics, guided walks, adventure games, and kid-friendly zones. Comfortable day-use accommodations and delicious local meals ensure a hassle-free experience. Ideal for families looking to escape the city for a refreshing and activity-packed day in nature."
    },
    {
      "name": "Nagpur Scenic Family Resort",
      "description": "Experience breathtaking views and serene landscapes at Nagpur Scenic Family Resort. The resort offers nature trails, riverside areas, hilltop viewpoints, and outdoor activity zones for families. Guests can enjoy guided treks, wildlife spotting, picnics, and cultural evenings. With cozy accommodations and eco-friendly amenities, this resort provides a perfect blend of adventure, relaxation, and natural beauty for family vacations or weekend escapes."
    }
  ],
  "tableData": [
    ["- Family Resort in Nagpur District Surrounded by Nature", "- Nagpur Nature Family Resort"],
    ["- Nagpur Eco-Friendly Family Stay", "- Nagpur Weekend Family Nature Resort"],
    ["- Nagpur Forest View Family Resort", "- Nagpur Riverside Family Resort"],
    ["- Nagpur Hill Family Resort", "- Nagpur Outdoor Activity Family Resort"],
    ["- Nagpur Nature Adventure Resort", "- Nagpur Group Family Resort"],
    ["- Nagpur Kids Friendly Nature Resort", "- Nagpur Booking for Family Resort"],
    ["- Nagpur Luxury Family Nature Resort", "- Nagpur One Day Family Resort"],
    ["- Nagpur Scenic Family Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect Family Resort Amidst Nature",
    "WhyChoosedescription": "Woodland Escape Resort offers a serene and scenic environment in Nagpur District, ideal for families seeking a peaceful getaway. Surrounded by lush greenery and forested landscapes, it provides a refreshing escape from the city bustle."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Family Accommodation",
    "WhyChoosedescription": "The resort features well-appointed rooms and cottages designed for families. With modern amenities and cozy interiors, every stay is comfortable, safe, and convenient, making it perfect for parents and children alike."
  },
  {
    "WhyChooseheading": "Nature Trails and Outdoor Activities",
    "WhyChoosedescription": "Families can enjoy guided nature walks, cycling trails, and open spaces for games and fun. Woodland Escape encourages outdoor bonding, allowing children to explore nature and adults to unwind amidst greenery."
  },
  {
    "WhyChooseheading": "Safe and Child-Friendly Environment",
    "WhyChoosedescription": "The resort prioritizes family safety with secure play areas, shaded spots, and monitored outdoor spaces. Parents can relax knowing children can enjoy outdoor adventures in a protected and friendly environment."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "Woodland Escape Resort serves freshly prepared meals, snacks, and beverages suitable for all ages. Families can enjoy local and continental cuisines together, making every meal a delightful experience."
  },
  {
    "WhyChooseheading": "Activities for All Age Groups",
    "WhyChoosedescription": "From light adventure sports to pond-side relaxation, the resort provides engaging options for every family member. Everyone from kids to grandparents can find something fun and relaxing to do."
  },
  {
    "WhyChooseheading": "Easily Accessible Yet Away from the City",
    "WhyChoosedescription": "Located a short drive from Nagpur city, Woodland Escape Resort allows families to enjoy nature without long travel. Its convenient location ensures more quality family time and less time on the road."
  }
]



























  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a family resort in Nagpur district surrounded by nature?",
    answer: "Woodland Escape Resort offers a peaceful and spacious natural setting in Nagpur district, making it an excellent choice for families wanting a nature‑immersed stay. With lush surroundings and open areas, it’s perfect for a family getaway."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort is located within driving distance from Nagpur city in Nagpur district, offering the convenience of access together with the tranquility of being surrounded by nature."
  },
  {
    question: "What facilities does Woodland Escape Resort offer for families in a natural setting?",
    answer: "The resort provides family‑friendly amenities such as spacious rooms, kids’ play areas, walking paths in green surroundings, open lawns, nature‑view balconies or sit‑outs, and activities that keep both children and adults engaged."
  },
  {
    question: "Is Woodland Escape Resort suitable for families with children and older members seeking a nature stay?",
    answer: "Absolutely! The resort is designed for family comfort in natural surroundings — children can play safely, older members can relax in calm green spaces, and the whole family can enjoy the serenity of nature together."
  },
  {
    question: "Does the resort provide food and additional services for a restful family stay amid nature?",
    answer: "Yes. Woodland Escape Resort offers freshly prepared meals, snacks and beverages. Family‑stay packages may include meals and comfortable services to complement your nature‑surrounded holiday."
  },
  {
    question: "How can we book Woodland Escape Resort for a nature‑surrounding family stay in Nagpur district?",
    answer: "You can book by calling or WhatsApp messaging the resort’s reservation team, or by visiting the official website. Advance booking is recommended, particularly for weekends and holiday periods."
  }
];

const testimonials = [
  {
    name: "Mr. Rajesh & Family, Nagpur",
    text: "Our family stay at Woodland Escape Resort was wonderful! The green surroundings, open spaces for the kids and the calm atmosphere made it a perfect nature‑stay in Nagpur district."
  },
  {
    name: "Ms. Anjali & Family, Nagpur",
    text: "Woodland Escape Resort gave us exactly the nature‑surrounded experience we were hoping for. The kids enjoyed the outdoors, and we adults relaxed in the greenery. Highly recommended for families."
  }
];
































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Family Resort in Nagpur District Surrounded by Nature",
  "image": "https://woodlandescape.com/assets/images/nagpur-nature-family-resort.jpg",
  "description": "Enjoy a relaxing family getaway at our Nagpur Nature Family Resort. Surrounded by lush greenery, rivers, and hills, this eco-friendly resort offers outdoor activities, kids-friendly amenities, and luxury stays for the whole family.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "42"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/nagpur-nature-family-resort"
  }
};


  return (
    <div>

<Helmet>
  <title>Family Resort in Nagpur District Surrounded by Nature | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Experience the perfect family getaway at Nagpur Nature Family Resort. Enjoy scenic views, rivers, hills, outdoor activities, eco-friendly stays, and kids-friendly facilities for a memorable family vacation." 
  />
  <meta 
    name="keywords" 
    content="Family Resort in Nagpur District Surrounded by Nature, Nagpur Nature Family Resort, Nagpur Eco-Friendly Family Stay, Nagpur Weekend Family Nature Resort, Nagpur Forest View Family Resort, Nagpur Riverside Family Resort, Nagpur Hill Family Resort, Nagpur Outdoor Activity Family Resort, Nagpur Nature Adventure Resort, Nagpur Group Family Resort, Nagpur Kids Friendly Nature Resort, Nagpur Booking for Family Resort, Nagpur Luxury Family Nature Resort, Nagpur One Day Family Resort, Nagpur Scenic Family Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/50.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Familyresortinnagpurdistrictsurroundedbynature;